import { render, staticRenderFns } from "./SurfDetailHeaderAffix.vue?vue&type=template&id=7449d220&scoped=true"
import script from "./SurfDetailHeaderAffix.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfDetailHeaderAffix.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfDetailHeaderAffix.vue?vue&type=style&index=0&id=7449d220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7449d220",
  null
  
)

export default component.exports